<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de proveedores</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-proveedor` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo proveedor</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Proveedores"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            @click:row="
                (item) => {
                    $router.push(`/guardar-proveedor?id=${item.id}`);
                }
            "
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            :server-items-length="total_cliente"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <!--router-link
                    :to="{ path: `/guardar-proveedor?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </~router-link-->
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="pointer-events: none; font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

export default {
    data() {
        return {
            total_cliente: 0,
            cantidad: 15,
            page: 1,
            search: "",
            headers: [
                { text: "Proveedor", value: "nombre", sortable: false },
                { text: "Email", value: "email", sortable: false },
                { text: "Teléfono", value: "telefono", sortable: false },
                { text: "Dirección", value: "direccion", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Proveedores: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        this.getProveedores();
    },
    methods: {
        ChangeSize(event) {
            this.cantidad = event;
            this.getProveedores();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getProveedores();
        },
        getProveedores() {
            axios
                .get(
                    `api/get-proveedores?page=${this.page}&amount=${
                        this.cantidad
                    }${this.search != null ? `&busqueda=${this.search}` : ""}`
                )
                .then(
                    (res) => {
                        //console.log(res.data.users);
                        this.Proveedores = res.data.data;
                        this.total_cliente = res.data.total;
                        //console.log(this.Proveedores);
                    },
                    (err) => {
                        this.$custom_error("Error consultando los proveedores");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Proveedores.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-proveedor", {
                    id: this.Proveedores[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Proveedor eliminado con éxito");
                        this.dialog = false;
                        this.getProveedores();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el proveedor");
                    }
                );
        },
    },
    watch: {
        search: debounce(function (val) {
            this.getProveedores();
        }, 500),
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
